// Next
import Head from "next/head"

// Utils
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

// Layout
import MainLayout from "src/layouts/mainLayout"

// Hooks
import { useIsMobile } from "src/hooks/useIsMobile"

// Components
import DesktopTransfer from "src/components/pages/requests/transfer/desktop"
import MobileTransfer from "src/components/pages/requests/transfer/mobile"
// ---------------------------------------|| Transfer - PAGES ||----------------------------------------------

const Transfer = () => {
  const isMobile = useIsMobile()
  return (
    <>
      <Head>
        <title>انتقال اعتبار</title>
      </Head>
      {isMobile ? <MobileTransfer /> : <DesktopTransfer />}
    </>
  )
}

Transfer.Layout = MainLayout

export default Transfer

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
